import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import SimpleSpinner from '@Components/Results/utils/SimpleSpinner';
import Button from '@Components/Button';
import useCellDetailsResults from '@Pages/Heatmap/HeatmapCellDetailsDialog/hooks/useCellDetailsResults';
import HeatmapCellDetailsAxisDescription from '@Pages/Heatmap/HeatmapCellDetailsDialog/components/HeatmapCellDetailsAxisDescription';
import ResultsList from '@Components/Results/ResultsList';
import history from '@AppRoutes/history';
import { closeDialog } from './actions';

function HeatmapCellDetailsDialogContent({ matrixName, params, cellData, axisDescription }) {
  const { isLoading, metadata, context, totalResults, resultsItems, showLoadMore, loadMore } = useCellDetailsResults({
    matrixName,
    params,
    cellData,
  });
  const dispatch = useDispatch();
  useEffect(() => {
    if (!history.location.pathname.includes('heatmap')) {
      dispatch(closeDialog());
    }
  }, [history.location.pathname]);

  return (
    <>
      <HeatmapCellDetailsAxisDescription
        title={axisDescription.x.title}
        subUnits={axisDescription.x.subUnits}
        label={axisDescription.x.label}
      />
      <HeatmapCellDetailsAxisDescription
        title={axisDescription.y.title}
        subUnits={axisDescription.y.subUnits}
        label={axisDescription.y.label}
      />
      {!isEmpty(resultsItems) && (
        <>
          <h4>{totalResults > 1 ? `Active substances - ${resultsItems.length} out of ${totalResults}` : 'Active substance'}</h4>
          <ResultsList metadata={metadata} context={context} results={resultsItems} size={resultsItems.length} hideCheckbox />
        </>
      )}
      {showLoadMore && !isLoading && (
        <div className="els-btn-group-center">
          <Button
            buttonConfig={{
              label: 'Load more',
              type: 'tertiary',
              size: 'sm',
              e2eName: 'load-more',
            }}
            iconConfig={{
              name: 'plus',
            }}
            onClick={loadMore}
          />
        </div>
      )}
      {isLoading && <SimpleSpinner className="heatmap-cell-details-dialog__spinner" />}
    </>
  );
}

HeatmapCellDetailsDialogContent.propTypes = {
  matrixName: PropTypes.string,
  params: PropTypes.object,
  cellData: PropTypes.object,
  axisDescription: PropTypes.object,
};

export default HeatmapCellDetailsDialogContent;
